<template>
    <div id="busattendance">
        <div class="container admin-wrap">
            <div class="row header mb-5">
                <div class="col-lg-7">
                    <h3 class="text-left mb-3">
                        {{lang('Bus Attendance')}}
                        <el-select v-model="ddlBusType" @change="getBusList()" placeholder="Select Type">
                            <el-option v-for="item in busTypeList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </h3>
                </div>
                <div class="col-lg-5">
                    <div class=" attendance-search">
                        <el-select v-model="ddlBus" :placeholder="lang('Select')" class="pro-edt-select"
                                   @change="Load()">
                            <el-option
                                    v-for="item in ddlBusList"
                                    :key="item.BusID"
                                    :label="item.BusNo"
                                    :value="item.BusID">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="pb-5">
                <div class="">
                    <div class="empty-list_image" v-if="attendanceList.length < 1">
                        <img src="../assets/attendance.jpg"/>
                    </div>
                    <div class="responsive-table" v-if="attendanceList.length > 0">
                        <div class="divSortBy">
                            <label>Sort By</label>
                            <el-select v-model="sortOptionsSelected" @change="changeSort()" placeholder="Sort By" class="pro-edt-select">
                                <el-option v-for="item in sortOptions" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                        <table class="attTable">
                            <tr>
                                <th>{{lang('Attendance')}}</th>
                                <th>{{lang('Student Name')}}</th>
                                <th>{{lang('Remarks')}}</th>
                                <th>{{lang('Parents Contact')}}</th>
                                <th>{{lang('ECA')}}</th>
                                <th>{{lang('Class (Level)')}}</th>
                            </tr>
                            <tr v-for="(item,i) in attendanceList" ref="attendanceList_Update">
                                <td :class="{'attendanceListDisableTickRow' : (item.markingStatusDisable === 'Yes') }">
                                    <vs-checkbox ref="studentCheck" v-model="item.markingStatus"
                                                 :checked="item.markingStatus === 'Yes'"
                                                 :disabled="item.markingStatusDisable === 'Yes'"></vs-checkbox>
                                </td>
                                <td :class="{'attendanceListDisableTickRow' : (item.markingStatusDisable === 'Yes') }">
                                    <label class="lblStudentName">{{ item.Full_Name }} {{ item.Middle_name }} {{ item.Last_name }}</label>
                                    <input type="text" class="form-control" ref="studentIndexNo" v-model="item.Index_No"
                                           style="display: none;">
                                </td>
                                <td :class="{'attendanceListDisableTickRow' : (item.markingStatusDisable === 'Yes') }">
                                    <input type="text" class="form-control" ref="studentRemark" v-model="item.remarks">
                                    <div v-if="item.attClassRemarks !== ''">
                                        <label class="lblClassAttRemark">
                                            {{lang('Attendance Remark')}}: <br>
                                            <span class="lblClassAttRemarkContent">{{item.attClassRemarks}}</span>
                                        </label>
                                    </div>
                                </td>
                                <td :class="{'attendanceListDisableTickRow' : (item.markingStatusDisable === 'Yes') }">
                                    <el-popover
                                            placement="bottom"
                                            width="200"
                                            trigger="click"
                                            popper-class="mobile-popover">
                                        <el-tag v-if="item.fatherMobile !== ''"
                                                v-clipboard:copy="item.fatherMobile"
                                                v-clipboard:success="onCopy"
                                                v-clipboard:error="onError"
                                                class="pointer">{{lang('Father')}} - {{ item.fatherMobile }}
                                        </el-tag>
                                        <el-tag v-if="item.fatherMobile === ''">{{lang('Father')}} - {{lang('Nil')}}</el-tag>
                                        <el-tag v-if="item.motherMobile !== ''"
                                                v-clipboard:copy="item.motherMobile"
                                                v-clipboard:success="onCopy"
                                                v-clipboard:error="onError"
                                                class="pointer">{{lang('Mother')}} - {{ item.motherMobile }}
                                        </el-tag>
                                        <el-tag v-if="item.motherMobile === ''">{{lang('Mother')}} - {{lang('Nil')}}</el-tag>
                                        <el-button slot="reference" type="primary" round>{{lang('Show Mobile')}}</el-button>
                                    </el-popover>
                                    <!--<select class="parentsMobileNo">-->
                                    <!--<option v-if="item.fatherMobile !== ''">Father - {{ item.fatherMobile }}-->
                                    <!--</option>-->
                                    <!--<option v-if="item.fatherMobile === ''">Father - Nil</option>-->
                                    <!--<option v-if="item.motherMobile !== ''">Mother - {{ item.motherMobile }}-->
                                    <!--</option>-->
                                    <!--<option v-if="item.motherMobile === ''">Mother - Nil</option>-->
                                    <!--</select>-->
                                </td>
                                <td>
                                    <label class="lblEcaName">{{ item.ecaName }}</label>
                                </td>
                                <td>
                                    <label class="lblClassLevelName">{{ item.className }} ({{ item.levelName }})</label>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="" v-if="attendanceList.length > 0">
                        <button type="button" class="btn btn-primary float-right" v-on:click="Save()">
                            {{lang('Save')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import DataSource from "../data/datasource";
    import {lang} from '../locale/index';
    import GlobalFn from "../components/GlobalFn";

    export default {
        name: "BusAttendance",
        components: {
            GlobalFn,
        },
        async created() {
        },
        data() {
            return {
                ddlBus: '',

                ddlBusList: [],
                attendanceList: [],
                sortOptionsSelected: '',
                sortOptions: ['Student Name', 'Class (Level)'],

                ddlBusType: '',
                busTypeList: ['IN','OUT'],
            };
        },
        methods: {
            lang,
            onCopy: function (e) {
                this.$notify.info({
                    message: e.text + lang(' was copied to the clipboard.')
                });
            },
            onError: function (e) {
                this.$notify.error({
                    message: ' fail to copy.'
                });
            },
            async getBusList() {
                try {
                    this.ddlBusList = [];
                    this.ddlBus = '';
                    this.attendanceList = [];

                    this.$vs.loading();

                    const response = await DataSource.shared.getBusMasterList(this.ddlBusType);

                    if (response) {
                        if (response.code === '2') {
                            this.$notify({
                                title: 'No Record',
                                message: 'No Bus Created...'
                            });
                        } else if (response.code === '99') {
                            console.log('getBusMasterList Error');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            this.ddlBusList = response.Table;
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
            },
            async Load() {
                try {
                    this.sortOptionsSelected = '';

                    if (this.ddlBus === '') {
                        this.$notify.error({
                            title: lang('Require'),
                            message: lang('Please select bus')
                        });
                    } else {
                        this.$vs.loading();

                        this.attendanceList = [];
                        const response = await DataSource.shared.LoadBusAttendanceList(this.ddlBus);
                        if (response) {
                            if (response.code === '2') {
                                this.$notify.error({
                                    title: lang('No Record'),
                                    message: lang('No student assign to this bus')
                                });

                                this.attendanceList = [];
                            } else if (response.code === '99') {
                                this.$notify.error({
                                    title: lang('Error'),
                                    message: lang('Error! Please try again later')
                                });
                            } else if (response.code === '88') {
                                window.location.replace('/');
                            } else {
                                this.attendanceList = [];

                                this.attendanceListResponse = response.Table;
                                this.attendanceListResponse = this.attendanceListResponse.filter(m => m.Status !== "Withdrawn");
                                // this.attendanceListResponse.forEach(m => {
                                //     if (m.markingStatus === 'Yes') {
                                //         m.markingStatus = true;
                                //     } else {
                                //         m.markingStatus = false;
                                //     }
                                //     this.attendanceList.push(m);
                                // });

                                this.attendanceListResponse.forEach(m => {
                                    if (m.markingStatusDisable !== 'Yes') {
                                        if (m.markingStatus === 'Yes') {
                                            m.markingStatus = true;
                                        } else {
                                            m.markingStatus = false;
                                        }
                                        this.attendanceList.push(m);
                                    }
                                });
                                this.attendanceListResponse.forEach(m => {
                                    if (m.markingStatusDisable === 'Yes') {
                                        if (m.markingStatus === 'Yes') {
                                            m.markingStatus = true;
                                        } else {
                                            m.markingStatus = false;
                                        }
                                        this.attendanceList.push(m);
                                    }

                                });

                                //this.attendanceList = response.Table;
                            }
                        }
                        this.$vs.loading.close();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async Save() {
                try {
                    let attendanceList = [];

                    this.$refs.attendanceList_Update.forEach((m, index) => {
                        let currentStatus = '';

                        if (this.$refs.studentCheck[index].isChecked === false || this.$refs.studentCheck[index].isChecked === undefined) {
                            currentStatus = 'No';
                        } else {
                            currentStatus = 'Yes';
                        }

                        let attendanceListTemp = {
                            busNo: this.ddlBus,
                            studentIndexNo: this.$refs.studentIndexNo[index].value,
                            status: currentStatus,
                            remark: this.$refs.studentRemark[index].value,
                        };

                        attendanceList.push(attendanceListTemp);
                    });

                    this.$vs.loading();
                    const response = await DataSource.shared.updateBusAttendanceList(JSON.stringify(attendanceList));
                    if (response) {
                        if (response.code === '99') {
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('Error! Please try again later')
                            });
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            //window.location.replace('/BusAttendance');
                            this.$notify({
                                title: lang('Success'),
                                message: lang('Successfully Saved')
                            });
                        }
                    }
                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
            },
            changeSort(){
                let attendanceListTemp = [];
                let attendanceListDisable = [];

                if (this.sortOptionsSelected === 'Student Name') {
                    attendanceListTemp = GlobalFn.SortObjectByKey(this.attendanceList, 'Full_Name', 'asc');
                } else if (this.sortOptionsSelected === 'Class (Level)') {
                    attendanceListTemp = GlobalFn.SortObjectByKey(this.attendanceList, 'className', 'asc');
                }

                attendanceListTemp.forEach(m => {
                    if (m.markingStatusDisable !== 'Yes') {
                        attendanceListDisable.push(m);
                    }
                });
                attendanceListTemp.forEach(m => {
                    if (m.markingStatusDisable === 'Yes') {
                        attendanceListDisable.push(m);
                    }
                });

                this.attendanceList = attendanceListDisable;
            },
        },
    };
</script>

<style scoped>
    .attTable {
        width: 100%;
        margin-top: 20px;
    }

    .attTable td, .attTable th, .attTable label {
        text-align: center;
        padding: 10px;
    }

    .attTable tr:nth-child(even) {
        background: #fff;
    }

    .parentsMobileNo {
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
    }

    .attendanceListDisableTickRow {
        background-color: #edf0f4;
        color: #c0c4cc;
    }

    .lblStudentName, .lblEcaName, .lblClassLevelName {
        font-weight: normal !important;
    }

    .lblClassAttRemark {
        text-align: left !important;
    }

    .lblClassAttRemarkContent {
        font-weight: normal;
    }

    .divSortBy {
        text-align: right;
    }
    .divSortBy label {
        display: inline !important;
        margin-right: 10px;
    }
</style>